var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-header"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"divider"}),_c('p',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }